import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import getters from './getter.js';
import actions from './actions.js';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
});